<template>
  <div class="main" v-loading="loading">
    <div class="hot-title">
      <dl>
        <dd @click="check(1)" :class="[timeActive === 1 ? 'active' : '']">
          当前聚焦
        </dd>
        <dd @click="check(2)" :class="[timeActive === 2 ? 'active' : '']">
          七天最热
        </dd>
        <dd @click="check(3)" :class="[timeActive === 3 ? 'active' : '']">
          30天最热
        </dd>
      </dl>
    </div>
    <div id="listTable" class="listTable">
      <div v-for="(list, indexList) in getData" :key="indexList">
        <div class="lineBox"></div>
        <div class="title-box">
          <div class="vocabulary">
            <span
              @click="goSc(item)"
              v-for="(item, index) in getTags(list.coreWords)"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <div>
            <span>{{ list.foundTime | changeTime() }}</span>
            话题：<span @click="goSc(list.hotWord)">{{ list.hotWord }}</span>
          </div>
        </div>
        <div class="main-box">
          <div>
            <a href="javascrip:;" @click="jump(list.imgLink)"
              ><img :src="imageShowUrl(list.coverImage)" @error="imgError(list)"
            /></a>
          </div>
          <div>
            <ul>
              <li
                v-for="(titles, tindex) of getTitles(list.recommendResources)"
                :key="tindex"
                @click="jump(titles[1])"
              >
                <span :title="titles[0]">{{ titles[0] }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      :total="rowCount"
      :current-page="pageable.pageIndex"
      :page-size="pageable.pageSize"
      :pager-count="5"
      @current-change="goPage"
      hide-on-single-page
    ></el-pagination>
    <!--    <popoutDetail-->
    <!--      guid="6FCBC6F3-0683-EA11-8DA3-20040FF9D71D"-->
    <!--      :isShow="true"-->
    <!--    ></popoutDetail>-->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Pageable } from "../../assets/script/model";
// import popoutDetail from "../../components/share/popoutDetail";
export default {
  name: "HotArticle",
  data() {
    return {
      getData: [],
      timeActive: 1,
      getid: null,
      loading: false,
      rowCount: 0
    };
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    pageable: {
      get() {
        return this.$store.state.hotList.Pageable;
      },
      set(val) {
        this.$store.state.hotList.Pageable = val;
      }
    },
    listGuid: {
      get() {
        return this.$store.state.hotList.listGuid;
      },
      set(val) {
        this.$store.state.hotList.listGuid = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "listTable", 35);
      }
    }
  },
  // components: {
  //   popoutDetail
  // },
  created() {
    this.getData = [];
    this.listGuid.RankingListGuid = "2A61B1E1-F632-E811-B201-D4AE52D0F72C";
    this.pageable = new Pageable(1, 20);
    this.getTopData();
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("listTable");
      if (getBox) {
        clearInterval(this.getid);
        this.getHotLineHeight(this.contentHeight, "listTable", 35);
      }
    }, 500);
  },
  methods: {
    ...mapActions("hotList", ["AMedia"]),
    check(type) {
      if (type) {
        this.timeActive = type;
        if (type === 1) {
          this.listGuid.RankingListGuid =
            "2A61B1E1-F632-E811-B201-D4AE52D0F72C";
          this.pageable = new Pageable(1, 20);
          this.getTopData();
        }
        if (type === 2) {
          this.listGuid.RankingListGuid =
            "2B61B1E1-F632-E811-B201-D4AE52D0F72C";
          this.pageable = new Pageable(1, 20);
          this.getTopData();
        }
        if (type === 3) {
          this.listGuid.RankingListGuid =
            "2C61B1E1-F632-E811-B201-D4AE52D0F72C";
          this.pageable = new Pageable(1, 20);
          this.getTopData();
        }
      }
    },
    async getTopData() {
      this.getData = [];
      this.loading = true;
      let result = await this.AMedia(
        Object.assign(this.listGuid, this.pageable)
      );
      if (result.errorCode === 0) {
        this.rowCount = result.data.rowCount;
        if (result.data.dataSource) {
          for (let item of result.data.dataSource) {
            if (item.recommendResources.length <= 0) {
              continue;
            }
            item.imgLink = this.getTitles(item.recommendResources)[0][1];
            this.getData.push(item);
          }
        }
      } else {
        this.$message({ message: result.errorMess, type: "error" });
      }
      this.loading = false;
    },
    getTags(tags) {
      tags = tags.split(",_");
      tags.length = 5;
      return tags;
    },
    goSc(words) {
      this.$router.push("/material/article/" + words);
    },
    jump(guid) {
      this.$router.push("/article/detail/" + guid);
    },
    getTitles(titls) {
      let list = [];
      titls = titls.split(",|");
      for (let item of titls) {
        item = item.split(",_");
        list.push(item);
      }
      return list;
    },
    goPage(pageIndex) {
      this.pageable.pageIndex = pageIndex;
      this.getTopData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.pageIndex();
.main {
  /*padding-right: 10px;*/
  width: 460px;
  font-size: 12px;
  .lineBox {
    height: 1px;
    border-top: 1px dashed #c3c3c3;
    background-color: #eee;
    flex: 1;
    /*margin-top: 10px;*/
  }
  .listTable {
    height: 500px;
    width: 100%;
    overflow: auto;
    overscroll-behavior-y: contain;
    padding-right: 10px;
  }
  .title-box {
    margin: 15px 0;
    div {
      flex: 1;
      &:nth-child(1) {
        text-align: left;
        float: left;
      }
      &:nth-child(2) {
        text-align: right;
        span {
          &:nth-child(1) {
            margin-right: 15px;
          }
          &:nth-child(2) {
            cursor: pointer;
            color: @theme-color;
          }
        }
      }
    }
  }
  .main-box {
    display: flex;
    margin: 10px 0;
    div {
      &:nth-child(1) {
        img {
          width: 110px;
          height: 80px;
        }
      }
      &:nth-child(2) {
        padding-left: 15px;
        color: #ccc;
        line-height: 26px;
      }
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 310px;
        color: #999;
        cursor: pointer;
      }
    }
  }
  .vocabulary {
    span {
      padding: 0 6px;
      cursor: pointer;
      border-left: 1px solid #eee;
      &:nth-child(1) {
        padding-left: 0;
        border-left: none;
      }
    }
  }
  .hot-title {
    dl,
    dd {
      display: inline-block;
      margin-right: 10px;
    }
    dl {
      color: #99999c;
      dd {
        padding: 10px 15px;
        height: 25px;
        line-height: 3px;
        cursor: pointer;
      }
    }
    height: 35px;
    .active {
      background: #ebf3fe;
      border-radius: 20px;
      color: @theme-color;
      border: 1px solid #d9d9dc;
    }
  }
}
</style>
